import { render, staticRenderFns } from "./ModalElectronicBigGame.vue?vue&type=template&id=2393002e&"
import script from "./ModalElectronicBigGame.vue?vue&type=script&lang=js&"
export * from "./ModalElectronicBigGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports